<script>
  import { External, M } from '../../external';
  import { DAY } from '../../Common/tools';
  import BasicFilter from '../../Store/BasicFilter.svelte';
  import LmsAnalytics from '../analytics/LmsAnalytics.svelte';
  import MembersTable from '../members/MembersTable.svelte';
  import { onMount } from 'svelte';
  import CircleMembersTable from '../members/CircleMembersTable.svelte';
  import Searchbox from '../../Common/Searchbox.svelte';

  export let circleDetails = null,
    entity = null,
    type = 'CIRCLE';

  let tabSelected = 'overview';
  let membersTab; // 'enrolled', 'completed', 'paid'
  let instance = null;
  let productIds = null;

  let now = new Date();
  let activePeriod = {
    label: M.LAST_SEVEN_DAYS,
    id: '7-days',
    from: new Date(now.getTime() - 6 * DAY),
    to: now
  };
  let onBasicFilterChange = (event) => {
    activePeriod = event.detail.period;
  };

  let selectMembersTab = (tabName) => {
    if (tabName === membersTab) {
      return;
    }
    membersTab = tabName;
    if (membersTab === 'enrolled') {
      setTimeout(() => {
        instance.reloadTable();
      }, 1);
    }
  };

  let selectTab = (tabName) => {
    if (tabName === tabSelected) {
      return;
    }
    tabSelected = tabName;
    if (tabSelected === 'members') {
      selectMembersTab('enrolled');
    } else {
      selectMembersTab(null);
    }
  };

  let getPageProductIds = (pages) => {
    return pages.filter((page) => page.access?.productId).map((page) => page.access?.productId);
  };

  let getGroupProductIds = (groupWithPages) => {
    let productIds = [];
    let groupProductId = groupWithPages.pageGroup.access?.productId;
    if (groupProductId) {
      productIds.push(groupProductId);
    }
    productIds.push(...getPageProductIds(groupWithPages.pages));
    return productIds;
  };

  let filters = {
    searchPhrase: null,
    onSearchPhraseChanged: function (term) {
      filters.searchPhrase = term;
      if (term == null) {
        filters.byNameFilter = [];
      } else {
        filters.byNameFilter = [{ func: 'startsWith', type: 7, id: -1, value: filters.searchPhrase }];
      }
      if (membersTab === 'enrolled') {
        setTimeout(() => {
          instance.reloadTable();
        }, 1);
      }
    },
    clearSearchFilters: function () {
      filters.onSearchPhraseChanged(null);
    },
    byNameFilter: []
  };
  const showSearch = (event) => {
    External.Tools.showFloatingPopup({
      markup: '<div class="col20 f-left bound-popup"></div>',
      width: 250,
      target: External.$(event.target),
      customClass: 'floating-popup-list',
      action: {
        onShow: function (popup, ui) {
          let component = new Searchbox({
            target: ui.find('.bound-popup')[0],
            props: {
              term: filters.searchPhrase,
              onSearch: function (term) {
                filters.onSearchPhraseChanged(term);
              }
            }
          });
          popup.component = component;
        },
        onHide: function (popup) {
          if (popup.component) {
            popup.component.$destroy();
            popup.component = null;
          }
        }
      }
    });
  };

  onMount(() => {
    productIds = [];
    if (type === 'CIRCLE') {
      if (entity.access?.productId) {
        productIds.push(entity.access?.productId);
      }
      circleDetails.groups.forEach((group) => {
        productIds.push(...getGroupProductIds(group));
      });

      productIds.push(...getPageProductIds(circleDetails.pages));
    } else if (type === 'GROUP') {
      let groupWithPages = circleDetails.groups.find((group) => group.pageGroup.id === entity.id);
      productIds.push(...getGroupProductIds(groupWithPages));
    } else if (type === 'PAGE') {
      if (entity.access?.productId) {
        productIds.push(entity.access.productId);
      }
    }
  });
</script>

<div class="sections-wrapper profile-inner-wrapper col20 f-left">
  <div class="top-background circle-analytics-head f-left col20 flex space-between align-center">
    <div class="text-wrapper flex align-center flex-col-mobile align-left-mobile col20 f-left">
      <h1 class="members-title f-left t-left" style="margin-bottom: 0px;">
        <!--{type === 'CIRCLE' ? 'Circle' : type === 'GROUP' ? 'Group' : 'Page'}-->
        {entity.name || ''}
        <!--{M.ANALYTICS}-->
      </h1>
      {#if tabSelected !== 'members'}
        <div class="flex align-center">
          <div class="f-left">
            <div class="custom-dropdown">
              <BasicFilter
                on:change={(event) => onBasicFilterChange(event)}
                period={activePeriod}
                withFunnels={false} />
            </div>
          </div>
        </div>
      {/if}
    </div>
    <div class="upper-navigation upper-navigation-full flex-none">
      <ul>
        {#if type === 'CIRCLE' && External.Website.hasPermission(External.Permission.COMMUNITY_MEMBERS)}
          <li on:click={() => selectTab('members')}>
            <a class:active={tabSelected === 'members'}>{M.MEMBERS}</a>
          </li>
        {/if}
        {#if type !== 'PAGE'}
          <li on:click={() => selectTab('overview')}>
            <a class:active={tabSelected === 'overview'}>{M.ANALYTICS}</a>
          </li>
          <li on:click={() => selectTab('content')}>
            <a class:active={tabSelected === 'content'}>{M.CONTENT}</a>
          </li>
        {/if}
      </ul>
    </div>
  </div>

  <div class="content-wrapper col20 f-left">
    <div class="col20 f-left">
      {#if tabSelected === 'members'}
        <div class="padding-45 f-left col20">
          <div class="upper-navigation upper-navigation-full inner-upper-nav mb-25">
            <ul>
              <li on:click={() => selectMembersTab('enrolled')}>
                <a class:active={membersTab === 'enrolled'}>{M.ENROLLED_PLURAL}</a>
              </li>
              <li on:click={() => selectMembersTab('completed')}>
                <a class:active={membersTab === 'completed'}>{M.COMPLETED_PLURAL}</a>
              </li>
              <li on:click={() => selectMembersTab('paid')}>
                <a class:active={membersTab === 'paid'}>{M.PAID_PLURAL}</a>
              </li>
              <li on:click={() => selectMembersTab('banned')}>
                <a class:active={membersTab === 'banned'}>{M.BANNED_PLURAL}</a>
              </li>
              <li on:click={() => selectMembersTab('muted')}>
                <a class:active={membersTab === 'muted'}>{M.MUTED_PLURAL}</a>
              </li>
              <li on:click={() => selectMembersTab('access_requested')}>
                <a class:active={membersTab === 'access_requested'}>{M.ACCESS_REQUESTED_PLURAL}</a>
              </li>
            </ul>
          </div>

          {#key filters.searchPhrase}
            <div class="f-right flex-centered">
              <div class="flex align-center search-inline-wrapper mobile-hidden">
                {#if filters.searchPhrase}
                  <a
                    on:click={filters.clearSearchFilters}
                    class="remove-search-btn flex align-center mr-5 rounded-effect">
                    <p class="f-left">{M.CLEAR}</p>
                    <p class="material-icons-outlined ml-5 f-left">cancel</p>
                  </a>
                {/if}
                <a
                  on:click={(event) => showSearch(event)}
                  class="circle-button blue rounded-effect flex align-center justify-center">
                  <span class="material-icons-outlined">search</span>
                </a>
              </div>
            </div>
            {#if ['completed', 'paid', 'banned', 'muted', 'access_requested'].includes(membersTab)}
              <CircleMembersTable
                type={membersTab}
                searchPhrase={filters.searchPhrase}
                circle={circleDetails.circle} />
            {:else}
              <MembersTable bind:this={instance} filters={filters.byNameFilter} circleId={circleDetails.circle.id} />
            {/if}
          {/key}
        </div>
      {:else if productIds !== null}
        {#key activePeriod}
          <LmsAnalytics {entity} {circleDetails} {activePeriod} {tabSelected} showTabs={false} {type} {productIds} />
        {/key}
      {/if}
    </div>
  </div>
</div>
